<h5 class="mb-1 pr-1 form-control-label text-break">{{ getTitle() }} </h5>
<div class="form-group">
  <div [ngClass]="{'border-bottom': model.summariesByCurrency.size > 1}" *ngFor="let s of model.summariesByCurrency | keyvalue">
  <div class="mt-1">
      <div class="d-flex justify-content-between pt-1 mb-1">
        <div class="font-weight-bold text-small">{{ 'FORM_RECORD_STOCK_SUM_NET_PRICE' | translate }}</div>
        <div>{{ s.value.netSumPrice | formattedNumber }} {{ s.key }}</div>
      </div>
      <div class="d-flex justify-content-between">
        <div class="font-weight-bold text-small">{{ 'FORM_RECORD_STOCK_SUM_GROSS_PRICE' | translate }}</div>
        <div>{{ s.value.grossSumPrice | formattedNumber }} {{ s.key }}</div>
      </div>
  </div>
  </div>
  <div class="mt-1" *ngIf="model.sumWeight > 0">
    <div class="">
      <div class="d-flex justify-content-between">
        <div class="font-weight-bold text-small">{{ 'FORM_RECORD_STOCK_SUM_WEIGHT' | translate }}</div>
        <div>{{ WeightFactory.createWeightFromGram(model.sumWeight) }}</div>
      </div>
    </div>
  </div>
  <div class="mt-1" *ngIf="model.sumBaseAmount > 0">
    <div class="">
      <div class="d-flex justify-content-between">
        <div class="font-weight-bold text-small">{{ 'FORM_RECORD_STOCK_SUM_BASE_AMOUNT' | translate }}</div>
        <div>{{ model.sumBaseAmount }}</div>
      </div>
    </div>
  </div>
</div>
